import {Linking} from 'react-native'

export default Linking
